<div>
  <ix-warning
    *ngIf="showWarning"
    class="warning"
    [message]="helpText.two_factor.qrCodeMessage | translate"
  ></ix-warning>

  <qr-code [value]="qrInfo" [size]="200"></qr-code>
</div>
